export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'home' */ 'components/bolt/home/home') },
	'boltGallery': { id: 'boltGallery', page: 'gallery', getter: () => import(/* webpackChunkName: 'gallery' */ 'components/bolt/gallery/gallery') },
	'boltSynopsis': { id: 'boltSynopsis', page: 'synopsis', getter: () => import(/* webpackChunkName: 'synopsis' */ 'components/bolt/synopsis/synopsis') },
	'signUp': { id: 'signUp', page: 'iframe', getter: () => import(/* webpackChunkName: 'iframe' */ 'components/bolt/iframe/iframe') },
	'sweeps': { id: 'sweeps', page: 'iframe', getter: () => import(/* webpackChunkName: 'iframe' */ 'components/bolt/iframe/iframe') }
};
export const sections = [
	{ id: 'boltPreviewPanel', getter: () => import(/* webpackChunkName: "previewPanel" */ 'components/bolt/previewPanel/previewPanel'), component: 'previewPanel', parent: 'boltHome' },
	{ id: 'boltWatchMore', getter: () => import(/* webpackChunkName: "watchMore" */ 'components/bolt/watchMore/watchMore'), component: 'watchMore', parent: 'boltHome' }
];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
